import { useState } from "react";
import { Download } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useStation } from "../lib/station";

export default function ExportButton({ kind, label, testId }) {
  const { activeId } = useStation();
  const [loading, setLoading] = useState(false);
  if (!activeId) return null;

  const handleClick = async () => {
    setLoading(true);
    try {
      const blob = await api.exportCsv(kind, activeId);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${kind}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      toast.success(`${kind}.csv downloaded`);
    } catch {
      toast.error("Export failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      data-testid={testId || `export-${kind}`}
      className="h-9 px-3 rounded-lg surface text-xs font-bold uppercase tracking-wider text-gray-300 hover:text-[#FF6B00] hover:border-[#FF6B00]/40 inline-flex items-center gap-2 transition-colors disabled:opacity-60"
    >
      <Download size={14} weight="bold" />
      {loading ? "…" : label || "CSV"}
    </button>
  );
}
